import React from 'react';
import LoadingComponent from '../commonComponents/LoadingComponent'
import NoDataFound from '../commonComponents/LoadingComponent'
import TableComponent from '../commonComponents/TableComponent'
import FeedbackComponent from '../commonComponents/FeedbackComponent'

var hrStyleGlobal = {
    margin: '11px 0px 12px -57px',
    width: '109.3%'
};
var topStyleGlobal = { marginLeft: '-1px', marginTop: '18px' };

class LoadData extends React.Component{
    constructor(props) {
        super(props);
        this.state={table: null}
    }
    componentDidMount() { 
        var that = this;
        var download_option=0
        if(download_option===1 || download_option==="1"){
            jQuery.ajax({
                type: 'get',
                url: '/dashboard/downloads/fetchdownloads',
                success: function (result) {
                    result = decodeResponseBody(result)
                    checkIfSessionTimedOut(result)
                    if (!result)
                        result = 0;
                    else result=that.modifyData(result);
                    that.setState({ table: result });
                }
            });
        }
        else{
            this.setState({
                table: 2
            })
        }
    }
    modifyData(result) {
        var finalResult = [];
        result.map(function (val, index) {
            var temp=[];
            var all_parameter=JSON.parse(val.parameter);
            // var property = all_parameter.selectedProperty.charAt(0).toUpperCase() + all_parameter.selectedProperty.slice(1);
            // var breakup=all_parameter.breakUp.split(',').map(function(val,index){
            //     val = val.split(';');
            //     if(index)
            //         return " and "+val[0]+" ("+val[1]+")";
            //     return val[0]+" ("+val[1]+")";
            // })
            // temp['label'] = "Extract: "+property+", Breakups:"+breakup;
            temp['label'] = val['title'];
            temp['File Size'] = val['file_size'];
            temp['Date Time'] = val['date_asked'];
            temp['Download Count'] = val['download_count'];
            temp['Save'] = '<a href="downloads/downloadsoption?srno='+val['srno']+'" target="_blank"><i class="fa fa-download"></i></a>';
            finalResult.push(temp);
        });
        return finalResult;
    }
    archiveReport(reportId) {
        var url = '/dashboard/savedreport/archivereport' + '?reportId=' + reportId;
        jQuery.ajax({
            type: 'get',
            url: url,
            success: function (result) {
                result = decodeResponseBody(result)
                checkIfSessionTimedOut(result)
                if (result) {
                    jQuery('#success').hide();       // when success show successful message
                    jQuery('#archived').show();       // when success show successful message
                    document.getElementById("archivedContent").innerHTML = "Report Archived Successfully!";
                    jQuery('#error').hide();         // and hide error message                
                    location.reload(); //reload page
                } else {
                    jQuery('#error').show();         // if error occurred call show the error pop-up 
                    jQuery('#success').hide();       // and hide the successful pop-up
                }
            }
        });
    }
    deleteReport(reportId) {
        var url = '/dashboard/savedreport/deletereport' + '?reportId=' + reportId;
        jQuery.ajax({
            type: 'get',
            url: url,
            success: function (result) {
                result = decodeResponseBody(result)
                checkIfSessionTimedOut(result)
                if (result) {
                    jQuery('#success').hide();       // when success show successful message
                    jQuery('#delete').show();       // when success show successful message
                    document.getElementById("deleteContent").innerHTML = "Report Deleted Successfully!";
                    jQuery('#error').hide();         // and hide error message                
                    location.reload(); //reload page
                } else {
                    jQuery('#error').show();         // if error occurred call show the error pop-up 
                    jQuery('#success').hide();       // and hide the successful pop-up
                }
            }
        });
    }
    updateReport(reportId) {
        var url = '/dashboard/savedreport/enablereport' + '?reportId=' + reportId;
        jQuery.ajax({
            type: 'get',
            url: url,
            success: function (result) {
                result = decodeResponseBody(result)
                checkIfSessionTimedOut(result)
                if (result) {
                    jQuery('#success').hide();       // when success show successful message
                    jQuery('#archived').show();       // when success show successful message
                    document.getElementById("archivedContent").innerHTML = "Report Un-Archived Successfully!";
                    jQuery('#error').hide();         // and hide error message                
                    location.reload(); //reload page
                } else {
                    jQuery('#error').show();         // if error occurred call show the error pop-up 
                    jQuery('#success').hide();       // and hide the successful pop-up
                    jQuery('#archived').hide();       // and hide the successful pop-u     
                }
            }
        });
    }
    handleFrequencyUpdate(e) {        
        var id = jQuery('#reportId').val();
        var oldFrequency = jQuery('#oldFrequency').val();
        var val = e.target.value;
        var message = '';
        switch (val) {
            case '-1':
                message = '';
                _paq.push(['trackEvent', 'Report', 'Frequency:None', 'Updated']);       
                break;
            case '1':
                message = 'This report will be scheduled at 06:00 Hours (IST) every day';
                _paq.push(['trackEvent', 'Report', 'Frequency:Day', 'Updated']);       
                break;
            case '2':
                message = 'This report will be scheduled on Monday at 06:00 Hours (IST) every week';
                _paq.push(['trackEvent', 'Report', 'Frequency:Week', 'Updated']);       
                break;
            case '3':
                message = 'This report will be scheduled on 1st of Every Month at 06:00 Hours (IST) every week';
                _paq.push(['trackEvent', 'Report', 'Frequency:Month', 'Updated']);       
                break;
        }
        jQuery('#frequencyTime').text(message);
        this.setState({ frequency: val, reportId: id });
    }
    updateFrequencyFunction(e) {
        var url = '/dashboard/savedreport/updatefrequency?id=' + this.state.reportId + '&frequency=' + this.state.frequency;
        jQuery.ajax({
            type:'get',
            url:url,
            success: function(done) { 
                done = decodeResponseBody(done)
                checkIfSessionTimedOut(done)
                if(done)
                    window.location.href = '/dashboard/savedreport';                    
            }
        });
    }
    formSubmit(event) {
        var password=document.getElementById('password').value;
        var outputData = [{'password': password}];
        var fd = new FormData();
        fd.append('update', JSON.stringify(outputData));
        fd = decodeResponseBody(fd)
        jQuery.ajax({
            type: 'POST',
            url: '/dashboard/downloads/checkpassword',
            data: fd,
            contentType: false,
            processData: false,
            success: function (response) {
                response = decodeResponseBody(response)
                checkIfSessionTimedOut(response)
                if(response!==false){
                    location.reload();
                }
                else alert("Password didn't matched.");
            }.bind(this)
        });
        event.preventDefault();
    }
    render() {
        if (this.state.table == null) 
            var tableDiv = <LoadingComponent />;
        else if (!this.state.table && this.state.table!=2) 
            var tableDiv = <NoDataFound data={'No Reports found'} />;
        else if(this.state.table===2){
            var tableDiv = <div className="col-md-6 mainCont" style={{minHeight:"auto"}}>
                <h4 style={{textAlign:"center"}}>Enter Password to continue.</h4>
                <div className="table-responsive">
                    <form autoComplete='off' onSubmit={this.formSubmit.bind(this)}>
                        <div className="form-group col-md-12">
                            <label>Password</label>
                            <input className="form-control" name="password" id="password" type="password" required />
                        </div>
                        <div className="form-group col-md-12">
                            <button className="btn btn-contrast" type="Submit">Submit</button>
                        </div>
                    </form>
                </div>
            </div>;
        }
        else if(this.state.table!=2){
            var main_data={"data":this.state.table};
            // date_asked:"2018-04-09 01:11:30",download_count:"0",parameter:"{"siteId":"223","toolId":"1247","selectedProperty":"raw","selectedMetric":"ENR;sum","breakUp":"Delhi;City","metricRange":"","startDate":"2017-01-01","endDate":"2017-12-30","executionStartTime":1523259690.043792,"userType":"1","userId":"515007176237827706","color":["#2f7ed8","#0d233a","#8bbc21","#910000","#1aadce","#492970","#f28f43","#77a1e5","#c42525","#a6c96a"]}",siteId:"223",srno:"5",status:"1",toolId:"1247",userId:"515007176237827706"
            var tableDiv = <TableComponent data={main_data} metrics={[{ label: 'Date Time', value: 'Date Time', type: 'text' },{ label: 'File Size', value: 'File Size', type: 'text' },{ label: 'Download Count', value: 'Download Count', type: 'text' },{ label: 'Save', value: 'Save', type: 'text' }]} setWidth={true} showTotalRow={false} chartEnable={false} link={false} index={1} />;
        }
        return (
            <div>
                <FeedbackComponent />
                <div >
                    <div id='mainDIVS'>
                        {tableDiv}
                    </div>
                </div>
            </div >
        );
    }
}

export default LoadData 
